import api from './api';

export interface Notification {
  id: string;
  userId: string;
  type: 'TASK_ASSIGNED' | 'TASK_MENTIONED' | 'TASK_STATUS_CHANGED' | 'TASK_DUE_SOON' | 'TASK_OVERDUE' | 'COMMENT_ADDED' | 'BOARD_INVITED' | 'DAILY_DIGEST';
  title: string;
  message: string;
  link?: string;
  read: boolean;
  createdAt: string;
  metadata?: any;
}

export const getNotifications = async (options?: { unreadOnly?: boolean; limit?: number }): Promise<Notification[]> => {
  const params = new URLSearchParams();
  if (options?.unreadOnly) params.append('unreadOnly', 'true');
  if (options?.limit) params.append('limit', options.limit.toString());
  
  const response = await api.get(`/api/notifications?${params.toString()}`);
  return response.data.data || response.data;
};

export const getUnreadCount = async (): Promise<number> => {
  const response = await api.get('/api/notifications/unread-count');
  return response.data.data?.count ?? response.data.count ?? 0;
};

export const markAsRead = async (notificationId: string): Promise<void> => {
  await api.put(`/api/notifications/${notificationId}/read`);
};

export const markAllAsRead = async (): Promise<void> => {
  await api.put('/api/notifications/read-all');
};

export const deleteNotification = async (notificationId: string): Promise<void> => {
  await api.delete(`/api/notifications/${notificationId}`);
};

